<template>
  <div class="all-style-bgc">
    <div class="Risk">
      <!-- 当前位置 -->
      <div class="box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <span class="dangqian">当前位置：</span>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <div class="red">业务领域</div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 布局容器 -->
      <div class="container">
        <!-- 左侧 -->
        <div class="left">
          <div class="top">
            <i class="iconfont iconbianzu10beifen3"></i>
            <p class="yi">业务领域</p>
          </div>
          <div
            class="smallBox"
            v-for="item in tabList"
            :key="item.id"
            :class="{ isActive: item.id == activeId }"
            @click="handle(item.id)"
          >
            {{ item.job }}
          </div>
        </div>
        <!-- 右侧 -->
        <div class="right">
          <el-carousel
            style="margin-bottom: 10px;padding: 0;overflow: hidden"
            height="450px"
          >
            <el-carousel-item v-for="(item, index) in imgsArr" :key="index">
              <img :src="item.filePath" style="width: 100%;height: 450px;" />
            </el-carousel-item>
          </el-carousel>
          <!-- <div
            v-for="(item, index) in imgsArr"
            :key="index"
            style="width: 80%;margin: 0 auto"
          >
            <img
              :src="item.filePath"
              align="center"
              class="imgs"
              style="height: 400px"
            />
          </div> -->
          <div class="text">
            {{ companyInfo }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgsArr: [],
      showPictureUrl: "",
      companyInfo: "",
      activeId: 1,
      type: "物流运输",
      tabList: [
        {
          id: 1,
          job: "物流运输",
        },
        {
          id: 2,
          job: "药品经营",
        },
      ],
      areShow: true,
      recValue: this.$route.params.activeId,
    };
  },
  created() {},
  mounted() {
    this.activeId = this.recValue;
    if (this.activeId == 1) {
      this.type = "物流运输";
    } else {
      this.type = "药品经营";
    }
    // 查询图片
    this.initImgsFun();
    // 查询文章
    this.searchContFun();
  },
  watch: {
    recValue(newVal, oldVal) {
      this.activeId = newVal;
    },
  },
  methods: {
    handle(id) {
      if (id == 1) {
        this.activeId = 1;
        this.type = "物流运输";
        this.initImgsFun();
        this.searchContFun();
      } else {
        this.activeId = 2;
        this.imgsArr = [];
        this.type = "药品经营";
        this.initImgsFun();
        this.searchContFun();
      }
    },
    initImgsFun() {
      this.Api.About0urManagementDataSearchimgApi({
        type: this.type,
      }).then((res) => {
        let that = this;
        that.showPictureUrl = res.Data.documentsIISHttp;
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.imgsArr.push(res.Data.pathfilename[i]);
        }
        for (let i = 0; i < res.Data.pathfilename.length; i++) {
          that.imgsArr[i].filePath =
            that.showPictureUrl +
            res.Data.pathfilename[i].dir +
            res.Data.pathfilename[i].filename;
        }
      });
    },
    searchContFun() {
      this.Api.About0urManagementDataSearchApi({
        type: this.type,
      }).then((res) => {
        if (res.Data.length == 0) {
          this.companyInfo = "";
        } else {
          this.companyInfo = res.Data[0].description;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__nav-wrap::after {
  content: "";
  height: 1px !important;
  background-color: #e4e7ed !important;
  z-index: 1;
}
/deep/ .el-tabs__item {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  padding: 0;
  margin: 0 20px;
}
/deep/ .is-active {
  color: red;
  border-bottom: 2px solid #00345e;
}
.Risk {
  background: #f2f2f2;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  width: 100%;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #00345e;
}

.yi {
  // margin-left: 10px;
  font-size: 16px;
  line-height: 50px;
  color: white;
}

.smallBox {
  width: 100%;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.left {
  width: 12%;
  height: 180px;
  background-color: white;
}
.top {
  margin-top: 24px;
  position: relative;
  width: 100%;
  height: 52px;
  line-height: 52px;
  background-color: #00345e;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  i {
    left: 10px;
  }
}
p {
  padding-left: 40px;
  color: white;
}

.isActive {
  background: #fce9ea;
}
.right {
  width: 88%;
  min-height: 546px;
  /*background-color: white;*/
  box-sizing: border-box;
  background: #fff;
  padding: 30px;
  overflow: auto;
  text-align: left;
  letter-spacing: 0.2ch;
  margin-left: 20px;
}
.right img {
  margin-right: 10px;
}
.imgs {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
}

.text {
  text-align: left;
  letter-spacing: 0.2ch;
  line-height: 25px;
}

i {
  position: absolute;
  left: 15px;
  width: 16px;
  height: 16px;
  color: white;
}
/deep/.el-breadcrumb {
  margin: 15px 0 20px 0;
  display: flex;
  align-items: center;
  line-height: 10px;
}
</style>
